import { type } from "os";
import { IProjectModel } from "./SharedModel";
import { QUEIRY_MODELS } from "./QueiryModels";

export type ICreateProjectInput = Pick<IProjectModel, 'project_name' | 'project_type' | 'version'| 'user_id' | 'username'> 

export interface IKDBProjectInput extends ICreateProjectInput {
  kdbName?: string;
  unique_kdb?:string;
  project_id?: string;
  prompt?: string;
  project_description?: string;
  user_id?:any;
  summarization_prompt?:any
  summarization_type?:any
  chat_history_op?:string;
  }

export enum chatHistryCommandTypes{
  chat_history_op='save_chat_hist',
  clear_history='clear_chat_history'
}

export interface IIngestKdbInput extends IKDBProjectInput {
  files: any;
  file_name?:string;
  reload:'String';
  project_id:string
  engine?:string;
}

export interface IDocUserQueryInput extends IKDBProjectInput {
  query?: string;
  prompt?:string;
  prompt_query?:any;
}

export interface IUserQueryInput extends IDocUserQueryInput {
  file_name: string;
}

export interface IKeyInfoInput extends IDocUserQueryInput {
  template: string;
  files: any;
  project_id: string;
  unique_kdb?:string
}

export interface ingest_training_data {
  project_id:string;
  data_dict:QUEIRY_MODELS[]
}

export interface ebook_summarization_v1{
  question_prompt: string;
	refined_prompt: string;
}

export enum summaryPromptType {
  // chapter
  heading_summary='heading_summary',
  // topic
  heading_summary_key='heading_summary_key',
  // custome_insights
  extract_topic = 'extract_topic',
  // custom_summary
  custom_insights = 'custom_insights'
}

export enum summaryType{
  compact="compact",
  standard="standard",
  comprehensive="comprehensive"
}